import ReCAPTCHA from "react-google-recaptcha";
import { useEffect, useState } from "react";

function BookingModal() {
    const [token, setToken] = useState(null);

  const [formData, setFormData] = useState({
    full_name: "",
    email_address: "",
    phone_no: "",
    total_persons: "",
    travel_date: "",
    destination: "",
    departure_city: "",
    package_name: "",
    package_id: "",
    page_url: "",
    child: "",
    adult: "",
    page_name: "",
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });
  const [pageType, setPageType] = useState("");

  useEffect(() => {
    const url = window.location.href;
    const path = window.location.pathname;
    const segments = path.split("/").filter(Boolean);


    const routeTypes = {
      "tour-package": "Tour Package",
      "tour-packages": "Tour Package",
      "activity": "Activity",
      "activities": "Activity",
      "cruise": "Cruise",
      "cruises": "Cruise",
      "blog": "Blog",
      "blogs": "Blog"
    };

    let detectedType = "";
    let slug = "";

    segments.forEach((segment, index) => {
      const key = segment.toLowerCase();
      if (routeTypes[key]) {
        detectedType = routeTypes[key];
        if (segments.length > index + 1) {
          slug = segments[index + 1];
        }
      }
    });

    if (!slug && segments.length > 0) {
       slug = segments[segments.length - 1];
    }

    const packageTitle = slug
      ?.replace(/-/g, " ")
      .replace(/\b\w/g, (l) => l.toUpperCase());

    setPageType(detectedType);
    
    setFormData((prev) => ({
      ...prev,
      destination: slug || "",
      package_name: packageTitle || "",
      page_url: url,
      page_name: packageTitle || "",
    }));

  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "", message: "" });
  
    try {
      const response = await fetch(
        "https://planjourneysglobal.com/admin/api/booking",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );
  if (!token) {
          alert("Please verify captcha");
          return;
        }

    console.log("Token:", token);
      const result = await response.json();

      if (response.ok) {
        setStatus({
          type: "success",
          message: "Booking request submitted successfully!",
        });

        setFormData((prev) => ({
          ...prev,
          full_name: "",
          email_address: "",
          phone_no: "",
          total_persons: "",
          travel_date: "",
          departure_city: "",
          child: "",
          adult: "",
        }));

        setTimeout(() => {
          const modalEl = document.getElementById("enquiryModals");
          const modal = window.bootstrap?.Modal.getInstance(modalEl);
          modal?.hide();
        }, 2000);
      } else {
        setStatus({
          type: "error",
          message: result?.message || "Something went wrong",
        });
      }
    } catch (error) {
      setStatus({
        type: "error",
        message: "Server error. Please try again later.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal fade" id="enquiryModals" tabIndex="-1">
      <div className="modal-dialog modal-md modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Book Your Trip</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" />
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <input type="hidden" name="destination" value={formData.destination} />
              
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Departure City *</label>
                  <input
                    type="text"
                    name="departure_city"
                    className="form-control"
                    value={formData.departure_city}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-6 d-none">
                  <label className="form-label">Package Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.package_name}
                    readOnly
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Full Name *</label>
                  <input
                    type="text"
                    name="full_name"
                    className="form-control"
                    value={formData.full_name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Phone *</label>
                  <input
                    type="tel"
                    name="phone_no"
                    className="form-control"
                    maxLength="10"
                    value={formData.phone_no}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Email *</label>
                  <input
                    type="email"
                    name="email_address"
                    className="form-control"
                    value={formData.email_address}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-6 Persons">
                  <label className="form-label">Person </label>
                  <input
                    type="number"
                    name="total_persons"
                    className="form-control"
                    min="1"
                    value={formData.total_persons}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6 Adults">
                  <label className="form-label">Adult *</label>
                  <input
                    type="number"
                    name="adult"
                    className="form-control"
                    min="1"
                    value={formData.adult}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6 Childs">
                  <label className="form-label">Child</label>
                  <input
                    type="number"
                    name="child"
                    className="form-control"
                    min="0"
                    value={formData.child}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Travel Date *</label>
                  <input
                    type="date"
                    name="travel_date"
                    className="form-control"
                    value={formData.travel_date}
                    onChange={handleChange}
                    required
                  />
                </div>
                 <div className="col-md-6">
                    <label className="form-label">Capthca *</label>
                  <ReCAPTCHA className="wrpaercp"
        sitekey="6LfXRZ8sAAAAADZ4XO4fQECm-adXRbal1rJxaPcv"
        onChange={(value) => setToken(value)}
      />
                </div>
              </div>

              {status.message && (
                <div
                  className={`alert mt-3 ${
                    status.type === "success" ? "alert-success" : "alert-danger"
                  }`}
                >
                  {status.message}
                </div>
              )}
            </div>

            <div className="modal-footer">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? "Submitting..." : "Book Now"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default BookingModal;